import { queryOptions, useQuery } from "tanstack-react-query-5";

import { getCart } from "../request.cart";

const getCartOptions = () => {
  return queryOptions({
    queryKey: ["getCart"],
    queryFn: getCart,
  });
};

const useGetCart = () => {
  return useQuery(getCartOptions());
};

export { getCartOptions, useGetCart };
